export interface Measurements {
  production?: number;
  grid?: number;
  consumption?: number;
  batteryPower?: number;
  batterySoC?: number;
}

export interface PlantPowerFlowProps {
  className?: string;
  width?: string;
  height?: string;
  measurements: Measurements;
}

export type FlowStyle = { readonly [key: string]: string };

export function isValidNumber(value: number | undefined): value is number {
  return value !== undefined && !isNaN(value);
}

export function getGridPlantFlow({ consumption, grid }: Measurements, style: FlowStyle) {
  if (!isValidNumber(consumption) || !isValidNumber(grid)) return;

  if (consumption === 0 || grid === 0) return;

  if (grid < 0 || consumption < 0) return;

  return {
    display: true,
    directionStyle: style.forward_flow,
  };
}

export function formatMeasurement(value: number | undefined, padStart: number): string {
  if (value === undefined) return '-'.padStart(padStart, ' ');

  if (isNaN(value)) return '-'.padStart(padStart, ' ');

  if (value === 0) return '0'.padStart(padStart, ' ');
  return String(Math.abs(value)).padStart(padStart, ' ');
}
